module.exports = __webpack_public_path__ + "static/media/course-placeholder-gray.01ecc56d.svg";